/** @param {string} key */
export const loadLocalStorage = (key) => {
  try {
    const serializedState = localStorage.getItem(key);
    if (!serializedState) {
      return null;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    console.log(error);
    return null;
  }
};
/**
 * @param {string} key
 * @param {*} payload
 */
export const saveLocalStorage = (key, payload) => {
  try {
    const serializedState = JSON.stringify(payload);
    localStorage.setItem(key, serializedState);
  } catch (error) {
    console.log(error);
  }
};

/** @param {string} key */
export const loadSessionStorage = (key) => {
  try {
    const serializedState = sessionStorage.getItem(key);
    if (!serializedState) {
      return null;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    console.log(error);
    return null;
  }
};
/**
 *
 * @param {string} key
 * @param {*} payload
 */
export const saveSessionStorage = (key, payload) => {
  try {
    const serializedState = JSON.stringify(payload);
    sessionStorage.setItem(key, serializedState);
  } catch (error) {
    console.log(error);
  }
};
